import type { CSSProperties } from 'react';
import clsx from 'clsx';
import type { VisualMatch } from '@frameio/graphql-client/generated';
import styles from './ClipMatchTimeline.module.css';
import { getClipRanges } from './utils';

type ClipMatchTimelineProps = {
  clips: VisualMatch['clips'];
  duration: number;
};

export const ClipMatchTimeline = ({
  clips,
  duration,
}: ClipMatchTimelineProps) => {
  if (!clips?.length) return null;

  const clipRanges = getClipRanges(clips, duration);

  return (
    <div className={styles.timelineContainer}>
      <div className={styles.clipRangeContainer}>
        {clipRanges.map((clipRange, index) => (
          <span
            key={`clip-${index}`}
            className={clsx(styles.clipRange, {
              [styles.clipRangeFirst]: index === 0,
            })}
            style={
              {
                '--offset-left': `${clipRange.offsetLeft}%`,
                '--range-width': `${clipRange.width}%`,
              } as CSSProperties
            }
          />
        ))}
      </div>
    </div>
  );
};
